'use strict';

var React = require('react');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const getWidth = () => {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return window.innerWidth || document?.documentElement?.clientWidth || document?.body?.clientWidth;
};
/**
 * React Hook that detects window resizing
 * @returns width
 * @example
 * ```javascript
 * const width = useWindowSize()
 * ```
 */
const useWindowSize = () => {
    const [width, setWidth] = React__namespace.useState(getWidth());
    React__namespace.useEffect(() => {
        let timeoutId = 0;
        const resizeListener = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => setWidth(getWidth()), 150);
        };
        const loadListener = () => {
            setWidth(getWidth());
        };
        window.addEventListener('resize', resizeListener);
        window.addEventListener('load', loadListener);
        return () => {
            window.removeEventListener('resize', resizeListener);
            window.removeEventListener('load', loadListener);
        };
    }, []);
    return width;
};

exports.useWindowSize = useWindowSize;
//# sourceMappingURL=useWindowSize.js.map
